import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { CompanyList } from "../../components/superadmin";

export const Companies = () => {
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate("/companies/add");
  };

  const buttons = [
    {
      buttonText: "Add Company",
      buttonIcon: Add,
      onClick: handleAddClick,
    },
  ];
  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title="Companies"
          subtitle={`${totalCount} Companies`}
          // button
          buttons={buttons}
        />
      </Box>
      {/* table section */}
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <CompanyList totalCount={totalCount} setTotalCount={setTotalCount} />
      </Box>
    </PageLayout>
  );
};
